import { Component, Input } from '@angular/core';
import { INotification } from './notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
})
export class NotificationComponent {
  @Input() notification: INotification;
}
